import axios from "axios";
import { environment } from '../config.env';

const ENDPOINT_DOMAIN = process.env.REACT_APP_ENDPOINT_DOMAIN || environment.endpoint_domain || ''

const domain = ENDPOINT_DOMAIN

export function getWebHookHospital() {
    return new Promise(resolve => {
        let url = `${domain}/api/v1/hospital/setting/webhook/getWebHook`
        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.get(url, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        })
    })
}

export function getHospitalWebHookHospital() {
    return new Promise(resolve => {
        let url = `${domain}/api/v1/hospital/setting/webhook/getHospital_webhook`
        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.get(url, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        })
    })
}

export function saveWebHookHospital(formState) {
    return new Promise(resolve => {
        let url = `${domain}/api/v1/hospital/setting/webhook/saveWebHook`
        let body = formState
        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.post(url, body, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        })
    })
}

export function removeWebHookHospital(webhook_id) {
    return new Promise(resolve => {
        let url = `${domain}/api/v1/hospital/setting/webhook/removeWebHook`
        let body = {
            "webhook_id" : webhook_id
        }
        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.post(url, body, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        })
    })
}